import ArticleFeed from './ArticleFeed'
export default ArticleFeed
